import { render, staticRenderFns } from "./FormBuilderElementDropArea.vue?vue&type=template&id=4aecb9a6&scoped=true&"
import script from "./FormBuilderElementDropArea.vue?vue&type=script&lang=js&"
export * from "./FormBuilderElementDropArea.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderElementDropArea.vue?vue&type=style&index=0&id=4aecb9a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aecb9a6",
  null
  
)

export default component.exports